var l = { icon: { tag: "svg", attrs: { viewBox: "0 0 100 100", focusable: "false", fill: "currentColor" }, children: [{ tag: "path", attrs: { d: "M97.82 26.49l-57.29 57.3a7.17 7.17 0 01-10.12.15l-.15-.15c-.13-.07-.17-.2-.24-.37-.17-.04-.25-.12-.41-.16L2.1 55.7a7.43 7.43 0 010-10.36 7.3 7.3 0 0110.3 0L35.44 68.4 87.6 16.2a7.12 7.12 0 0110.06-.17l.18.18a7.18 7.18 0 01.1 10.16l-.12.12z", "fill-rule": "nonzero" } }] }, name: "right", theme: "filled" };
export {
  l as default
};
